import { render, staticRenderFns } from "./multi-upload-side-action.vue?vue&type=template&id=40cb4156"
import script from "./multi-upload-side-action.ts?vue&type=script&lang=js&external"
export * from "./multi-upload-side-action.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports